//==============================
// Global
//==============================

// Global variables
var w = $(window);
var ww = w.width();
var wh = w.height();
var html = $('html');
var body = $('body');

// FastClick
FastClick.attach(document.body);

// FitVids
$('.video-gallery-item, .video, .post-content p, .wp-block-embed__wrapper, .home-videos-item').fitVids();

// Commerce7 email field placeholder
setTimeout(function() {
  $('.c7-subscribe input[type="email"]').attr('placeholder', 'Email address');
}, 1500);
